import { render, staticRenderFns } from "./FinishedProsthesisButton.vue?vue&type=template&id=1d52712c&scoped=true"
import script from "./FinishedProsthesisButton.vue?vue&type=script&lang=js"
export * from "./FinishedProsthesisButton.vue?vue&type=script&lang=js"
import style0 from "./FinishedProsthesisButton.vue?vue&type=style&index=0&id=1d52712c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d52712c",
  null
  
)

export default component.exports